// extracted by mini-css-extract-plugin
export default {"loading":"custom-ink-footer-module__loading___Qx3TK"};